import {getToken} from '@/utils/auth'

// post接口拼接
export function http_post_params(data) {
  var key = Object.keys(data)
  var val = Object.values(data)
  var str = '?'
  for (var i = 0; i < key.length; i++) {
      // if (val[i]) {
          str += `${key[i]}=${val[i]?val[i]:''}`
          if (i != key.length - 1) {
              str += '&'
          }
      // }
  }
  return str
}

//时间戳转时间
export function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

// 时长转换 秒转换成 时分秒
export function formatDuration(duration) {
    const hours = Math.floor(duration / 3600); // 计算小时
    const minutes = Math.floor((duration % 3600) / 60); // 计算分钟
    const seconds = duration % 60; // 计算秒钟

    // 返回格式化的字符串，确保两位数
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

// 流式数据请求
export function deepSeekChat(message, onDataReceived, onComplete, onError) {
	let baseApi = process.env.VUE_APP_BASE_API;
	// 发起请求
	let thinkingTime = true;
  fetch(`${baseApi}/misnPc/deepseek/chat`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
			Accept: "text/event-stream",
      'pcToken': getToken(),
    },
    body: JSON.stringify({content:message}),
  })
    .then((response) => response.body.getReader())
    .then((reader) => {
      const decoder = new TextDecoder();
      let partialReasoningContent = ""; // 推理内容
      let partialContent = ""; // think 后内容
			let buffer = '';
 

      // 处理接收到的消息
      function processMessage(message) {
				message = message.split("data:")[0];

        //解析深度思考
        if (message.includes("<think>")) {
          thinkingTime = true;
        }
        if (message.includes("</think>")) {
          thinkingTime = false;
        }
        if (thinkingTime) {
					// console.log('推理思考：',message)
					const data = JSON.parse(message);
					if(data.choices[0]?.delta?.content){
						var content = data.choices[0]?.delta?.content.replace("<think>\n", "").trimEnd() || '';
						partialReasoningContent += content
					}
        } else {
					// console.log('开始解答：',message)
					const data = JSON.parse(message);
					if(data.choices[0]?.delta?.content){
						// var content = data.choices[0]?.delta?.content.replace("</think>", "").trim() || '';
            var content = data.choices[0]?.delta?.content.replace("</think>", "").trimEnd() || '';
						partialContent += content
					}
        }

        if (message.includes("[DONE]")) {
          
        }
        return false;
			}

      function processStream({ done, value }) {
        if (done) {
          // 流式读取完成
          onComplete({ partialReasoningContent, partialContent });
          return;
        }

				// 解码当前数据块
				buffer += decoder.decode(value, { stream: true });

				// 处理完整的事件 -- 非统一处理方法，需根据业务需求和接口数据格式处理
				while (buffer.includes("data:")) {
					if (buffer.includes("[DONE]")) {
						
					}
					const eventEndIndex = buffer.indexOf("data:");
					let eventData = buffer.slice(0, eventEndIndex);
					buffer = buffer.slice(eventEndIndex + 5);
					eventData = eventData.substring(0, eventData.lastIndexOf('\n\n'))
					const message = eventData;
					if (eventData) {
						if (processMessage(message)) return;
					}
				}
 
        onDataReceived({ partialReasoningContent, partialContent, thinkingTime });
        // 继续读取下一块数据
        reader.read().then(processStream).catch(onError);
      }
 
      // 开始读取流
      reader.read().then(processStream).catch(onError);
    })
    .catch((error) => {
      console.error("调用 DeepSeek API 出错:", error);
      onError(error);
    });
}

export function urlFrom(goUrl, from) {
  // // 假设这是后台给的链接
  // let url = goUrl;
  // // 创建一个 URL 对象，便于操作查询参数
  // let link = new URL(url);
  // // 检查是否有 `from` 参数
  // if (link.searchParams.has('from')) {
  //   link.searchParams.set('from', from);
  // } else {
  //   link.searchParams.append('from', from);
  // }
  // // 获取修改后的链接
  // let modifiedUrl = link.toString();
  // return modifiedUrl;

  // 检查 URL 是否包含 'from' 参数
  if (goUrl.indexOf('from=') !== -1) {
    // 如果包含，替换 'from' 参数的值为 'teamIntroduction'
    goUrl = goUrl.replace(/from=[^&]*/, 'from=' + from);
  } else {
    // 如果不包含，添加 'from=teamIntroduction'
    if (goUrl.indexOf('?') !== -1) {
      goUrl += '&from=' + from;
    } else {
      goUrl += '?from=' + from;
    }
  }
  return goUrl;
}